import { useEffect } from "react";

export const ADMIN_REFRESH_EVENT = "admin-app-refresh";

/** Подписка страницы на глобальный pull-to-refresh в AdminAppShell. */
export function useAdminRefresh(handler) {
  useEffect(() => {
    if (!handler) return undefined;
    const fn = () => {
      handler();
    };
    window.addEventListener(ADMIN_REFRESH_EVENT, fn);
    return () => window.removeEventListener(ADMIN_REFRESH_EVENT, fn);
  }, [handler]);
}

export function dispatchAdminRefresh() {
  window.dispatchEvent(new CustomEvent(ADMIN_REFRESH_EVENT));
}
